import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import { searchHandle } from "../features/filter/filterSlice";

export default function Navbar() {
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const currentPath = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(searchHandle(search));
  }, [search, dispatch, currentPath, navigate]);
  const handleSearch = (e) => {
    setSearch(e.target.value);
    if (currentPath.pathname !== "/") navigate("/");
  };
  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <Link to={"/"}>
          <img src={logo} alt="" />
        </Link>
        <div className="flex-1 max-w-xs search-field group">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input
            type="text"
            placeholder="Search Task"
            className="search-input"
            id="lws-searchTask"
            style={{ color: "black" }}
            value={search}
            onChange={handleSearch}
          />
        </div>
      </div>
    </nav>
  );
}
